import { cartValidationAddon, addressesAddon } from './actionAddons';

export const actionAddonMiddleware = store => next => action => {
  // NOTE: Add action-addons here, order is important
  const addons = [cartValidationAddon, addressesAddon];

  // Update action
  const updatedAction = addons.reduce((action, addon) => addon(store, action), action);

  // TODO: Ensure core action preservation
  return next(updatedAction);
};
